module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ac9f131d636c99b928a.worker.js");
};